export default {
  appName: 'Media24 - Contech Media',
  companyName: 'Contech Media',
  footer: '© Contech Media Ltd, Mauritius',
  logoUrl: '/img/logo.png',
  environment: {
    development: {
      apiUrl: 'http://localhost:3002'
    },
    production: {
      apiUrl: 'https://avails-africa-bp.eu-4.evennode.com'
    }
  }
}
